import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { Field } from "@atlaskit/form";
import Textfield from "@atlaskit/textfield";

import { wacToken } from "@/libraries/design/foundations";

import { useSiteActivationContext } from "../../hooks";
import { Dropdown, Label } from "../common";

export const SitePicker = () => {
    const { sites, isWorkspaceProduct } = useSiteActivationContext();

    const label = (
        <Label>
            {isWorkspaceProduct ? (
                <FormattedMessage
                    id="siteActivation.yourWorkspace"
                    defaultMessage="Your workspace"
                />
            ) : (
                <FormattedMessage
                    id="siteActivation.siteNameSitePickerLabel"
                    defaultMessage="Your site"
                />
            )}
        </Label>
    );

    if (sites.length === 1) {
        return (
            <div css={inputCss}>
                <Field
                    aria-required
                    isRequired
                    isDisabled
                    name="site-picker-field"
                    id="site-picker-field"
                    testId="site-picker-field"
                    label={label}
                    defaultValue={sites[0]?.url.replace("https://", "")}
                >
                    {({ fieldProps }) => <Textfield {...fieldProps} />}
                </Field>
            </div>
        );
    }

    return <Dropdown sites={sites} />;
};

const inputCss = css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- needed to style atlaskit input
    ["span[title='required']"]: {
        display: "none"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- needed to style atlaskit input
    ['div[role="presentation"]']: {
        borderRadius: 21
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- needed to style atlaskit input
    ["input[disabled]"]: {
        backgroundColor: wacToken("color.neutral.light100"),
        color: wacToken("color.neutral.light400"),
        WebkitTextFillColor: "inherit",
        fontSize: 16,
        fontWeight: 400,
        fontFamily: "inherit",
        padding: "6px 8px 6px 16px"
    }
});
